import Content from './content';
import UI from './ui';
export default class View {
    constructor() {
        this.ui = new UI();
        this.content = new Content(this);
    }
}
